<script lang="ts">
	import Icon from '$lib/elements/Icon.svelte';
	import ButtonBoxPrimary from '$lib/elements/buttons/variants/ButtonBoxPrimary.svelte';
	import { storyblokEditable } from '@storyblok/svelte';
	import { richTextToHTML } from '@app/utils/cms';

	export let blok: {
		icon: string;
		title: string;
		desc: string;
		cta: Record<string, any>;
		isContainerWidth: boolean;
	};
</script>

{#if blok}
	<div
		use:storyblokEditable={blok}
		class="flex flex-col items-center text-center space-y-5 container {blok.isContainerWidth
			? ''
			: 'lg:w-2/3 xl:w-1/2'}"
	>
		{#if blok.icon}
			<Icon name={blok.icon} size="huge" classNames="text-primary" />
		{/if}
		<div>
			{#if blok.title}
				<h3>{blok.title}</h3>
			{/if}
			<div>
				{@html richTextToHTML(blok.desc)}
			</div>
		</div>
		{#if blok.cta[0]}
			<ButtonBoxPrimary
				props={{
					label: blok.cta[0].label,
					href: blok.cta[0].link.url || `/${blok.cta[0].link.cached_url}`,
					hrefTarget: blok.cta[0].target_blank ? 'blank' : '',
					iconLeft: blok.cta[0].icon ? blok.cta[0].icon : ''
				}}
			/>
		{/if}
	</div>
{/if}

<style lang="postcss">
	div :global(h2) {
		&:before,
		&:after {
			@apply hidden;
		}
	}
</style>
